import { render, staticRenderFns } from "./UnlockFeedView.vue?vue&type=template&id=3823099a&scoped=true&"
import script from "./UnlockFeedView.vue?vue&type=script&lang=ts&"
export * from "./UnlockFeedView.vue?vue&type=script&lang=ts&"
import style0 from "./UnlockFeedView.vue?vue&type=style&index=0&id=3823099a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3823099a",
  null
  
)

export default component.exports